import { useState } from "react";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const login = async () => {
    const res = await fetch("https://thakkar-backend.vercel.app/api/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password })
    });

    const data = await res.json();

    if (!data.success) return alert("Invalid credentials");

    localStorage.setItem("token", data.token);
    localStorage.setItem("role", data.role);

    navigate("/admin");
  };

  return (
    <div className="h-screen flex items-center justify-center">
      <div className="p-8 bg-white shadow rounded-xl w-96">
        <h2 className="text-xl font-bold mb-4">Admin Login</h2>

        <input
          className="w-full border p-3 mb-3"
          placeholder="Email"
          onChange={(e)=>setEmail(e.target.value)}
        />

        <input
          className="w-full border p-3 mb-4"
          type="password"
          placeholder="Password"
          onChange={(e)=>setPassword(e.target.value)}
        />

        <button
          onClick={login}
          className="w-full bg-black text-white py-3 rounded-lg"
        >
          Login
        </button>
      </div>
    </div>
  );
};

export default AdminLogin;
